import { SerializedStyles } from '@emotion/react';
import {
  useFocusable,
  UseFocusableConfig
} from '@noriginmedia/norigin-spatial-navigation';
import { FC, PropsWithChildren } from 'react';

import * as styles from './styles';

interface FocusableButtonProps extends UseFocusableConfig, PropsWithChildren {
  buttonStyle?: SerializedStyles;
  focusedStyle?: SerializedStyles;
}

const FocusableButton: FC<FocusableButtonProps> = (props) => {
  const { buttonStyle, focusedStyle, children } = props;
  const { ref, focused } = useFocusable({ ...props });
  return (
    <div
      ref={ref}
      css={[
        styles.button,
        buttonStyle,
        ...(focused ? [styles.focused, focusedStyle] : [])
      ]}
    >
      {children}
    </div>
  );
};

export default FocusableButton;
